'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userInfoSync = exports.userInfoSafe = exports.userInfoWithDelegatedOptions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _promise = require('./helpers/promise');

var _loginVerifyClient = require('./clients/loginVerifyClient');

var _loginVerifyClient2 = _interopRequireDefault(_loginVerifyClient);

var _events = require('./helpers/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var memoizedPromise = void 0;
var memoizedInfo = void 0;

var getUserInfo = function getUserInfo(options) {
  var _options$cached = options.cached,
      cached = _options$cached === undefined ? true : _options$cached,
      otherOptions = _objectWithoutProperties(options, ['cached']);

  // don't use early requester if we're trying to refresh the data


  if (!cached && otherOptions.externalResponse) {
    delete otherOptions.externalResponse;
  }

  if (cached && memoizedPromise) {
    otherOptions.recycledPromise = memoizedPromise;
  }

  var loginVerifyCall = (0, _loginVerifyClient2.default)('/login-verify', otherOptions);

  if (!cached || !memoizedPromise) {
    memoizedPromise = loginVerifyCall;
  }

  return loginVerifyCall.then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};

var expired = function expired(data) {
  return data.auth && data.auth.access_token.expires_at && new Date() - new Date(data.auth.access_token.expires_at) > 0;
};

var refreshFromLegacy = function refreshFromLegacy(options, data) {
  return options.legacyLoginVerify && data.auth == null;
};

var earlyRequestPromise = void 0;
var earlyRequest = function earlyRequest() {
  if (!earlyRequestPromise) {
    earlyRequestPromise = new _promise.Promise(function (resolve, reject) {
      var request = window.earlyRequester && window.earlyRequester.getRequestStateByName('api-verify');
      if (!request) {
        reject();
      } else {
        request.whenFinished(function (data) {
          return expired(data) ? reject() : resolve(data);
        });
        request.onError(function (xhr) {
          reject(new Error('[hub-http] EarlyRequester token refresh attempt failed with status ' + xhr.status + ': ' + xhr.statusText));
        });
      }
    });
  }

  return earlyRequestPromise;
};

var get = function get(options) {
  // when earlyRequester fails, pass control over to the login verify client to try again
  var fallback = function fallback(reason) {
    if (reason) {
      // eslint-disable-next-line no-console
      console.error(reason.message);
    }

    return getUserInfo(options);
  };

  // when earlyRequester succeeds, send a dummy response in the login verify's client for processing
  var dummyResponse = function dummyResponse(response) {
    return {
      status: 200,
      statusText: 'OK',
      data: response
    };
  };

  var request = earlyRequest().then(function (response) {
    return getUserInfo(_extends({}, options, { externalResponse: dummyResponse(response) }));
  }).catch(fallback);

  return request.then(function (_ref2) {
    var auth = _ref2.auth,
        portal = _ref2.portal,
        user = _ref2.user;

    var info = {
      user: user,
      gates: portal.enabled_gates,
      portal: portal
    };

    if (auth) {
      info.auth = auth;
    }

    (0, _events.triggerEvent)('hubspot:userinfochange', info);
    return info;
  });
};

var userInfo = function userInfo() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$refreshOnExp = options.refreshOnExpiredToken,
      refreshOnExpiredToken = _options$refreshOnExp === undefined ? false : _options$refreshOnExp,
      others = _objectWithoutProperties(options, ['refreshOnExpiredToken']);

  return get(others).then(function (data) {
    return refreshOnExpiredToken && expired(data) || refreshFromLegacy(options, data) ? get(_extends({ cached: false }, others)) : data;
  }).then(function (data) {
    memoizedInfo = data;
    return data;
  });
};

var userInfoWithDelegatedOptions = exports.userInfoWithDelegatedOptions = function userInfoWithDelegatedOptions(_ref3) {
  var cached = _ref3.cached,
      refreshOnExpiredToken = _ref3.refreshOnExpiredToken,
      ignoreRedirect = _ref3.ignoreRedirect,
      safeMode = _ref3.safeMode,
      allowSuspended = _ref3.allowSuspended;
  return userInfo({
    cached: cached,
    refreshOnExpiredToken: refreshOnExpiredToken,
    ignoreRedirect: ignoreRedirect,
    safeMode: safeMode,
    allowSuspended: allowSuspended
  });
};

var userInfoSafe = exports.userInfoSafe = function userInfoSafe(options) {
  return userInfo(_extends({}, options, { safeMode: true }));
};

var userInfoSync = exports.userInfoSync = function userInfoSync() {
  if (!memoizedInfo) {
    throw new Error('User info has not be loaded yet. Did you call userInfoSync before the userInfo promise resolved?');
  }

  return memoizedInfo;
};

exports.default = userInfo;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.158/js/userInfo.js
// module id = 177
// module chunks = 0